import { useState, useMemo } from 'react'
import { useTheme } from '../../contexts/ThemeContext'
import { STORAGE_KEYS } from '../../lib/storage'

const RECOMENDACIONES = [
  '¿hay algo que ajustarías la semana que viene?',
  'los pequeños cambios se acumulan.',
  '¿qué patrón ves en tus gastos de esta semana?',
  'la constancia importa más que la perfección.',
]

function getWeekNumber() {
  const d = new Date()
  d.setHours(0, 0, 0, 0)
  d.setDate(d.getDate() + 4 - (d.getDay() || 7))
  const yearStart = new Date(d.getFullYear(), 0, 1)
  return Math.ceil(((d - yearStart) / 86400000 + 1) / 7)
}

export default function WeeklyResetBanner({ gastos, metas }) {
  const { theme } = useTheme()
  const s = makeStyles(theme)

  const [dismissed, setDismissed] = useState(() => {
    const last = parseInt(localStorage.getItem(STORAGE_KEYS.WEEKLY_DISMISSED) || '0')
    return (Date.now() - last) < 7 * 86400000
  })

  const stats = useMemo(() => {
    const hace7 = Date.now() - 7 * 86400000
    const semana = gastos.filter(g => g.tipo === 'gasto' && new Date(g.fecha).getTime() >= hace7)
    const total = semana.reduce((a, g) => a + g.monto, 0)

    const cats = semana.reduce((a, g) => ({ ...a, [g.categoria]: (a[g.categoria] || 0) + g.monto }), {})
    const topCat = Object.entries(cats).sort((a, b) => b[1] - a[1])[0]?.[0] || null

    const meta = metas[0] || null
    const metaPct = meta && meta.objetivo > 0 ? Math.round((meta.acumulado / meta.objetivo) * 100) : null

    return { total, topCat, meta, metaPct }
  }, [gastos, metas])

  if (dismissed || stats.total === 0) return null

  const rec = RECOMENDACIONES[getWeekNumber() % RECOMENDACIONES.length]

  function handleDismiss() {
    localStorage.setItem(STORAGE_KEYS.WEEKLY_DISMISSED, Date.now().toString())
    setDismissed(true)
  }

  return (
    <div style={s.banner}>
      <div style={s.header}>
        <p style={s.eyebrow}>resumen de la semana ✦</p>
        <button style={s.closeBtn} onClick={handleDismiss}>×</button>
      </div>

      <div style={s.stats}>
        <div style={s.stat}>
          <span style={s.statValue}>${stats.total.toLocaleString('es')}</span>
          <span style={s.statLabel}>gastado</span>
        </div>
        {stats.topCat && (
          <div style={s.stat}>
            <span style={s.statValue}>{stats.topCat}</span>
            <span style={s.statLabel}>categoría top</span>
          </div>
        )}
        {stats.metaPct !== null && (
          <div style={s.stat}>
            <span style={s.statValue}>{stats.metaPct}%</span>
            <span style={s.statLabel}>{stats.meta.nombre}</span>
          </div>
        )}
      </div>

      <p style={s.rec}>{rec}</p>
    </div>
  )
}

const makeStyles = (t) => ({
  banner: {
    background: t.goldPale + 'CC', borderRadius: 18,
    border: `1.5px solid ${t.gold}44`, padding: '16px 18px',
    marginBottom: 16,
  },
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 },
  eyebrow: {
    fontFamily: "'DM Sans', sans-serif", fontSize: 11,
    letterSpacing: 1.5, textTransform: 'uppercase',
    color: t.inkMid, fontWeight: 500, margin: 0,
  },
  closeBtn: {
    background: 'none', border: 'none', fontSize: 20,
    color: t.inkLight, cursor: 'pointer', lineHeight: 1, padding: '0 2px',
  },
  stats: { display: 'flex', gap: 20, marginBottom: 12 },
  stat: { display: 'flex', flexDirection: 'column', gap: 2 },
  statValue: {
    fontFamily: "'Cormorant Garamond', serif", fontSize: 18, fontWeight: 600, color: t.ink,
  },
  statLabel: {
    fontFamily: "'DM Sans', sans-serif", fontSize: 11, color: t.inkLight,
    textTransform: 'uppercase', letterSpacing: 1,
  },
  rec: {
    fontFamily: "'Lora', serif", fontStyle: 'italic', fontSize: 15,
    color: t.inkMid, margin: 0, lineHeight: 1.5,
  },
})
